import React from 'react'

 const Dummy = () => {
  return (
    <div>
        Development List 
    </div>
  )
}
export default Dummy;